import {
  Icon,
  // Still renders inline SVG, so <Icon name> would swap the glyph, not just
  // the mechanism.
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-24381
  CircleOutlineIcon,
} from '@latitude/icons';
import type { ReactNode } from 'react';

import { EmptyPersonIcon } from './EmptyPersonIcon';

// Canonical icon-key -> icon node map for the KYC nav menus, shared
// between the onboarding app's NavigationMenu and the questionnaire-builder
// feature's SideMenu preview panel.
//
// Nodes rather than components, so the two entries with no sprite symbol can
// sit beside the sprite-backed ones without the map taking both shapes.
// Consumers size these: a node cannot receive a per-render className.
const FALLBACK_ICON = <CircleOutlineIcon />;

const MENU_ICONS: Record<string, ReactNode> = {
  use_outline: <EmptyPersonIcon />,
  user_outline: <EmptyPersonIcon />,
  user_add: <Icon name="user-plus" />,
  business: <Icon name="building" />,
  browser_transfer: <Icon name="transferbrowser" />,
  shield_tick: <Icon name="shield-tick" />,
  puzzle_piece: <Icon name="puzzle-piece" title="Puzzle" />,
  activity: <Icon name="activity" />,
  bar_line_chart: <Icon name="bar-line-chart" />,
};

// Falls back to a generic outline icon for unrecognized keys
export function getMenuIcon(icon: string): ReactNode {
  return MENU_ICONS[icon] ?? FALLBACK_ICON;
}
